import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  Typography,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import module from "./HistoryTransfer.module.css";
import TableRow from "@mui/material/TableRow";
import { API, Auth } from "aws-amplify";
import { getAccountDetail } from "../graphql/queries";
import { useNavigate } from "react-router-dom";
import fetchRewards from "../util/fetchRewards";
import { convertDate } from "../util/date";

const detail = {
  transfer_at: "2021-07-28",
  total: 10501,
  fee: 500,
  rewards: [
    {
      id: "id_7181",
      date: "2021-07-28",
      category: "紹介",
      amount: 4,
      subtotal: 80000,
    },
    {
      id: "id_7184",
      date: "2022-07-28",
      category: "紹介",
      amount: 1,
      subtotal: 20000,
    },
    {
      id: "id_7161",
      date: "2023-05-03",
      category: "入会",
      amount: 1,
      subtotal: 100,
    },
  ],
};

const HistoryTransfer = () => {
  const [date, setDate] = useState(null);
  const [transfer, setTransfer] = useState(null); // {}
  const [bankInfo, setBankInfo] = useState(null); // {}
  const navigate = useNavigate();

  const getQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const date = urlParams.get("date");
    setDate(date);
    return date;
  };

  const isDateRegex = (item) => {
    const regex = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/;
    return regex.test(item);
  }

  const redirectToHistory = () => {
    navigate("/mypage/history");
    return [];
  }

  const hasError = (item) => {
    if (item === '' || item === null || item === undefined) {
      return true;
    }

    if (!isDateRegex(item)) {
      return true;
    }

    const dateItem = new Date(item);
    if (isNaN(dateItem.getTime())) {
      return true;
    }

    return false;
  }

  const getRewards = async (date) => {
    const user = await Auth.currentAuthenticatedUser();
    const sub = user.attributes.sub;
    const result = await fetchRewards(sub);
    if (!result.length) {
      navigate("/mypage/reward/history");
    }

    if (hasError(date)) {
      redirectToHistory();
    }

    const paramDate = new Date(date);
    const isDateMatched = result.some((reward) => {
      const transferredAt = reward.transferredAt;
      const transferredAtDate = new Date(transferredAt);
      return paramDate.getTime() === transferredAtDate.getTime();
    });
    if (!isDateMatched) {
      redirectToHistory();
    }

    const targetRewards = result.filter((item) => item.transferredAt === date);
    return targetRewards;
  };

  const convertTransfer = (rewards) => {
    let total = 0;
    const converted = [];
    rewards.forEach((item) => {
      total += item.amount;
      const rewardDate = convertDate(item.createdAt);
      if (converted.some((data) => data.date === rewardDate)) {
        const index = converted.findIndex((data) => data.date === rewardDate);
        converted[index].amount += item.amount;
        converted[index].dataNum += 1;
      } else {
        const data = {
          ...item,
          date: rewardDate,
          category: "紹介",
          dataNum: 1,
        };
        converted.push(data);
      }
    });
    converted.sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    });
    const transfer = {
      transferredAt: date,
      total,
      rewards: converted,
    };
    return transfer;
  };

  const fetchTransfer = async (date) => {
    const targetRewards = await getRewards(date);
    const transferData = convertTransfer(targetRewards);
    setTransfer(transferData);
  };

  const fetchBankInfo = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const bankInfo = await API.graphql({
        query: getAccountDetail,
        variables: {
          user_id: user.attributes.sub,
        },
      });
      if (!bankInfo.data.getAccountDetail) {
        alert("口座情報が読み込めませんでした。再登録してください");
        navigate("/mypage/reward/setting");
        return null;
      }
      setBankInfo(bankInfo.data.getAccountDetail);
    } catch (e) {
      console.log(e);
      alert("口座情報が読み込めませんでした。");
    }
  };

  useEffect(() => {
    const date = getQueryParams();
    fetchTransfer(date);
    fetchBankInfo();
  }, [date]);

  const Cell = styled(TableCell)(() => ({
    padding: "16px 8px",
    width: "8px",
  }));

  const FeeCell = styled(TableCell)(() => ({
    padding: "16px 8px",
    width: "8px",
    borderBottom: "none",
  }));

  const BankCell = styled(TableCell)(() => ({
    padding: "8px 4px",
    width: "50px",
    borderBottom: "none",
    fontWeight: "0.8rem",
  }));

  return (
    <div className={module.container}>
      <Box sx={{ padding: "4px" }}>
        {transfer ? (
          <h1 className={module.title}>お振込み履歴</h1>
        ) : (
          <CircularProgress color="success" />
        )}
      </Box>
      {transfer && (
        <>
          <Box
            sx={{ backgroundColor: "#15B855", padding: "24px 0px", color: "white" }}
          >
            <Typography
              component={"span"}
              sx={{ position: "relative", bottom: "2px", marginRight: "8px" }}
            >
              振込金額
            </Typography>
            <Typography
              component={"span"}
              sx={{ fontSize: "1.7rem", fontWeight: "bold" }}
            >
              {transfer.total.toLocaleString()}
            </Typography>
            <Typography
              component={"span"}
              sx={{
                fontWeight: "bold",
                fontSize: "1.1rem",
              }}
            >
              円
            </Typography>
          </Box>
          <div className={module.transferred_at}>
            <span>お振込日 </span>
            <span>{ date && convertDate(date)}</span>
          </div>
          <div className={module.transferDetail}>
            {transfer.rewards ? (
              <div>
                <div className={module.tableTitle}>
                  <span>お振込明細</span>
                </div>
                <Table sx={{ width: "100%" }}>
                  <TableBody>
                    {transfer.rewards.map((reward, i) => (
                      <TableRow
                        sx={{
                          borderTop: i === 0 && "1px solid rgba(224, 224, 224, 1)",
                        }}
                        key={`${reward.date}-${i}`}
                      >
                        <Cell>{reward.date}</Cell>
                        <Cell>{reward.category}</Cell>
                        <Cell>{reward.dataNum}件</Cell>
                        <Cell
                          sx={{ color: "#15B855", fontWeight: "bold" }}
                          align="right"
                        >
                          {reward.amount.toLocaleString()}円
                        </Cell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <CircularProgress color="success" />
            )}
          </div>
          <div className={module.transferDetail}>
            <div className={module.tableTitle}>
              <span>お振込先情報</span>
            </div>
            <div>
              {bankInfo ? (
                <Table sx={{ width: "100%" }}>
                  <TableBody>
                    <TableRow>
                      <BankCell>金融機関名</BankCell>
                      <BankCell>{bankInfo.bank_name}</BankCell>
                    </TableRow>
                    <TableRow>
                      <BankCell>支店名</BankCell>
                      <BankCell>{bankInfo.branch_name}</BankCell>
                    </TableRow>
                    <TableRow>
                      <BankCell>口座区分</BankCell>
                      <BankCell>
                        {bankInfo.account_category === "normal" ? "普通" : "当座"}
                      </BankCell>
                    </TableRow>
                    <TableRow>
                      <BankCell>口座番号</BankCell>
                      <BankCell>{bankInfo.account_num}</BankCell>
                    </TableRow>
                    <TableRow>
                      <BankCell>口座名義</BankCell>
                      <BankCell>{bankInfo.account_person_name}</BankCell>
                    </TableRow>
                  </TableBody>
                </Table>
              ) : (
                <CircularProgress color="success" />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HistoryTransfer;
